import i18n from '@/i18n'
export default {
  columns: (vm) => {
    return [{
      type: 'index',
      width: 120,
      align: 'center'
    },{
      title: i18n.t('alarm.columns.097043-0'),
      key: 'UserDeviceName',
      resizable: true,
      minWidth: 160,
      sortable: true,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-1'),
      key: 'DeviceCode',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-2'),
      key: 'Address',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-3'),
      key: 'IsOnline',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.IsOnline ? i18n.t('alarm.columns.097043-4') : i18n.t('alarm.columns.097043-5'));
      }
    },
    {
      title: i18n.t('alarm.columns.097043-6'),
      key: 'SwitchStatus',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center',
      render: (h, params) => {
        return h('span', {}, params.row.SwitchStatus === 1 ? i18n.t('alarm.columns.097043-7') : params.row.SwitchStatus === 2 ? i18n.t('alarm.columns.097043-8') : '-');
      }
    },
    {
      title: i18n.t('alarm.columns.097043-9'),
      key: 'OwnerName',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-10'),
      key: 'AddressDetail',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-11'),
      key: 'Longitude',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-12'),
      key: 'Latitude',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('alarm.columns.097043-13'),
      key: 'action',
      width: 150,
      align: 'center',
      fixed: 'right',
      render: (h, params) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'success',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                vm.handleUser(params.row)
              }
            }
          }, i18n.t('alarm.columns.097043-14'))
        ]);
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/useGas/views/alarm/columns.js